import { produce } from "immer";
import {
  FETCH_MAINTENANCE_DASHBOARD,
  FETCH_MAINTENANCE_DASHBOARD_SUCCESS,
  FETCH_MAINTENANCE_DASHBOARD_FAILURE,
  //
  FETCH_MAINTENANCE_REQUESTS,
  FETCH_MAINTENANCE_REQUESTS_SUCCESS,
  FETCH_MAINTENANCE_REQUESTS_FAILURE,
  //
  ADD_MAINTENANCE_REQUEST,
  ADD_MAINTENANCE_REQUEST_SUCCESS,
  ADD_MAINTENANCE_REQUEST_FAILURE,
  //
  FETCH_MAINTENANCE_REQUEST,
  FETCH_MAINTENANCE_REQUEST_SUCCESS,
  FETCH_MAINTENANCE_REQUEST_FAILURE,
  //
  EDIT_MAINTENANCE_REQUEST,
  EDIT_MAINTENANCE_REQUEST_SUCCESS,
  EDIT_MAINTENANCE_REQUEST_FAILURE,
  //
  DELETE_MAINTENANCE_REQUEST,
  DELETE_MAINTENANCE_REQUEST_SUCCESS,
  DELETE_MAINTENANCE_REQUEST_FAILURE,
  //
  UPDATE_MAINTENANCE_REQUEST_STATUS,
  UPDATE_MAINTENANCE_REQUEST_STATUS_SUCCESS,
  UPDATE_MAINTENANCE_REQUEST_STATUS_FAILURE,
  //
  FETCH_MAINTENANCE_INSPECTIONS,
  FETCH_MAINTENANCE_INSPECTIONS_SUCCESS,
  FETCH_MAINTENANCE_INSPECTIONS_FAILURE,
  //
  ADD_MAINTENANCE_INSPECTION,
  ADD_MAINTENANCE_INSPECTION_SUCCESS,
  ADD_MAINTENANCE_INSPECTION_FAILURE,
  //
  FETCH_MAINTENANCE_INSPECTION,
  FETCH_MAINTENANCE_INSPECTION_SUCCESS,
  FETCH_MAINTENANCE_INSPECTION_FAILURE,
  //
  SUBMIT_MAINTENANCE_INSPECTION,
  SUBMIT_MAINTENANCE_INSPECTION_SUCCESS,
  SUBMIT_MAINTENANCE_INSPECTION_FAILURE,
  //
  FETCH_MAINTENANCE_ASSETS,
  FETCH_MAINTENANCE_ASSETS_SUCCESS,
  FETCH_MAINTENANCE_ASSETS_FAILURE,
  //
  ADD_MAINTENANCE_ASSET,
  ADD_MAINTENANCE_ASSET_SUCCESS,
  ADD_MAINTENANCE_ASSET_FAILURE,
  //
  FETCH_MAINTENANCE_ASSET,
  FETCH_MAINTENANCE_ASSET_SUCCESS,
  FETCH_MAINTENANCE_ASSET_FAILURE,
  //
  EDIT_MAINTENANCE_ASSET,
  EDIT_MAINTENANCE_ASSET_SUCCESS,
  EDIT_MAINTENANCE_ASSET_FAILURE,
  //
  DELETE_MAINTENANCE_ASSET,
  DELETE_MAINTENANCE_ASSET_SUCCESS,
  DELETE_MAINTENANCE_ASSET_FAILURE,
  //
  SET_ASSET_ADD_EDIT_MODAL,
  //
  FETCH_MAINTENANCE_COMPLIANCE,
  FETCH_MAINTENANCE_COMPLIANCE_SUCCESS,
  FETCH_MAINTENANCE_COMPLIANCE_FAILURE,
  //
  ADD_MAINTENANCE_COMPLIANCE,
  ADD_MAINTENANCE_COMPLIANCE_SUCCESS,
  ADD_MAINTENANCE_COMPLIANCE_FAILURE,
  //
  FETCH_MAINTENANCE_COMPLIANCE_ITEM,
  FETCH_MAINTENANCE_COMPLIANCE_ITEM_SUCCESS,
  FETCH_MAINTENANCE_COMPLIANCE_ITEM_FAILURE,
  //
  EDIT_MAINTENANCE_COMPLIANCE,
  EDIT_MAINTENANCE_COMPLIANCE_SUCCESS,
  EDIT_MAINTENANCE_COMPLIANCE_FAILURE,
  //
  DELETE_MAINTENANCE_COMPLIANCE,
  DELETE_MAINTENANCE_COMPLIANCE_SUCCESS,
  DELETE_MAINTENANCE_COMPLIANCE_FAILURE,
  //
  FETCH_MAINTENANCE_SCHEDULES,
  FETCH_MAINTENANCE_SCHEDULES_SUCCESS,
  FETCH_MAINTENANCE_SCHEDULES_FAILURE,
  //
  ADD_MAINTENANCE_SCHEDULE,
  ADD_MAINTENANCE_SCHEDULE_SUCCESS,
  ADD_MAINTENANCE_SCHEDULE_FAILURE,
  //
  EDIT_MAINTENANCE_SCHEDULE,
  EDIT_MAINTENANCE_SCHEDULE_SUCCESS,
  EDIT_MAINTENANCE_SCHEDULE_FAILURE,
  //
  DELETE_MAINTENANCE_SCHEDULE,
  DELETE_MAINTENANCE_SCHEDULE_SUCCESS,
  DELETE_MAINTENANCE_SCHEDULE_FAILURE,
  //
  GET_MAINTENANCE_SCHEDULE,
  GET_MAINTENANCE_SCHEDULE_SUCCESS,
  GET_MAINTENANCE_SCHEDULE_FAILURE,
  SET_SCHEDULE_ADD_EDIT_MODAL,
  //
  ACTIVATE_ALL_PRESETS,
  ACTIVATE_ALL_PRESETS_SUCCESS,
  ACTIVATE_ALL_PRESETS_FAILURE,
  //
  FETCH_MAINTENANCE_LOCATION_SETTING,
  FETCH_MAINTENANCE_LOCATION_SETTING_SUCCESS,
  FETCH_MAINTENANCE_LOCATION_SETTING_FAILURE,
  //
  SAVE_MAINTENANCE_LOCATION_SETTING,
  SAVE_MAINTENANCE_LOCATION_SETTING_SUCCESS,
  SAVE_MAINTENANCE_LOCATION_SETTING_FAILURE,
  //
  FETCH_INSPECTION_TEMPLATES,
  FETCH_INSPECTION_TEMPLATES_SUCCESS,
  FETCH_INSPECTION_TEMPLATES_FAILURE,
  //
  ADD_INSPECTION_TEMPLATE,
  ADD_INSPECTION_TEMPLATE_SUCCESS,
  ADD_INSPECTION_TEMPLATE_FAILURE,
  //
  EDIT_INSPECTION_TEMPLATE,
  EDIT_INSPECTION_TEMPLATE_SUCCESS,
  EDIT_INSPECTION_TEMPLATE_FAILURE,
  //
  DELETE_INSPECTION_TEMPLATE,
  DELETE_INSPECTION_TEMPLATE_SUCCESS,
  DELETE_INSPECTION_TEMPLATE_FAILURE,
  //
  CLONE_INSPECTION_TEMPLATE,
  CLONE_INSPECTION_TEMPLATE_SUCCESS,
  CLONE_INSPECTION_TEMPLATE_FAILURE,
  //
  SET_TEMPLATE_ADD_EDIT_MODAL,
  //
  ADD_INSPECTION_FROM_TEMPLATE,
  ADD_INSPECTION_FROM_TEMPLATE_SUCCESS,
  ADD_INSPECTION_FROM_TEMPLATE_FAILURE,
  //
  FETCH_CQC_REPORT,
  FETCH_CQC_REPORT_SUCCESS,
  FETCH_CQC_REPORT_FAILURE,
  //
  FETCH_INSPECTION_REPORT,
  FETCH_INSPECTION_REPORT_SUCCESS,
  FETCH_INSPECTION_REPORT_FAILURE,
  //
  SET_REQUEST_CREATE_MODAL,
  //
  FETCH_MAINTENANCE_QUOTES,
  FETCH_MAINTENANCE_QUOTES_SUCCESS,
  FETCH_MAINTENANCE_QUOTES_FAILURE,
  FETCH_MAINTENANCE_QUOTE,
  FETCH_MAINTENANCE_QUOTE_SUCCESS,
  FETCH_MAINTENANCE_QUOTE_FAILURE,
  ADD_MAINTENANCE_QUOTE,
  ADD_MAINTENANCE_QUOTE_SUCCESS,
  ADD_MAINTENANCE_QUOTE_FAILURE,
  EDIT_MAINTENANCE_QUOTE,
  EDIT_MAINTENANCE_QUOTE_SUCCESS,
  EDIT_MAINTENANCE_QUOTE_FAILURE,
  DELETE_MAINTENANCE_QUOTE,
  DELETE_MAINTENANCE_QUOTE_SUCCESS,
  DELETE_MAINTENANCE_QUOTE_FAILURE,
  ACCEPT_MAINTENANCE_QUOTE,
  ACCEPT_MAINTENANCE_QUOTE_SUCCESS,
  ACCEPT_MAINTENANCE_QUOTE_FAILURE,
  //
  FETCH_COMPLIANCE_MATRIX,
  FETCH_COMPLIANCE_MATRIX_SUCCESS,
  FETCH_COMPLIANCE_MATRIX_FAILURE,
  FETCH_SCHEDULED_COMPLETED_CHECKS_REPORT,
  FETCH_SCHEDULED_COMPLETED_CHECKS_REPORT_SUCCESS,
  FETCH_SCHEDULED_COMPLETED_CHECKS_REPORT_FAILURE,
  FETCH_MONTHLY_SCHEDULE_CHECKLIST_REPORT,
  FETCH_MONTHLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  FETCH_MONTHLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  FETCH_WEEKLY_SCHEDULE_CHECKLIST_REPORT,
  FETCH_WEEKLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  FETCH_WEEKLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  FETCH_QUARTERLY_SCHEDULE_CHECKLIST_REPORT,
  FETCH_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  FETCH_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  FETCH_ANNUAL_SCHEDULE_CHECKLIST_REPORT,
  FETCH_ANNUAL_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  FETCH_ANNUAL_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  EXPORT_MONTHLY_SCHEDULE_CHECKLIST_REPORT,
  EXPORT_MONTHLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  EXPORT_MONTHLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  EXPORT_WEEKLY_SCHEDULE_CHECKLIST_REPORT,
  EXPORT_WEEKLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  EXPORT_WEEKLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  EXPORT_QUARTERLY_SCHEDULE_CHECKLIST_REPORT,
  EXPORT_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  EXPORT_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  EXPORT_ANNUAL_SCHEDULE_CHECKLIST_REPORT,
  EXPORT_ANNUAL_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  EXPORT_ANNUAL_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  FETCH_BIANNUAL_SCHEDULE_CHECKLIST_REPORT,
  FETCH_BIANNUAL_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  FETCH_BIANNUAL_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  EXPORT_BIANNUAL_SCHEDULE_CHECKLIST_REPORT,
  EXPORT_BIANNUAL_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  EXPORT_BIANNUAL_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  FETCH_DAILY_SCHEDULE_CHECKLIST_REPORT,
  FETCH_DAILY_SCHEDULE_CHECKLIST_REPORT_SUCCESS,
  FETCH_DAILY_SCHEDULE_CHECKLIST_REPORT_FAILURE,
  //
  ADD_MAINTENANCE_INVOICE,
  ADD_MAINTENANCE_INVOICE_SUCCESS,
  ADD_MAINTENANCE_INVOICE_FAILURE,
  EDIT_MAINTENANCE_INVOICE,
  EDIT_MAINTENANCE_INVOICE_SUCCESS,
  EDIT_MAINTENANCE_INVOICE_FAILURE,
  DELETE_MAINTENANCE_INVOICE,
  DELETE_MAINTENANCE_INVOICE_SUCCESS,
  DELETE_MAINTENANCE_INVOICE_FAILURE,
  //
  UPDATE_INSPECTION_STATUS,
  UPDATE_INSPECTION_STATUS_SUCCESS,
  UPDATE_INSPECTION_STATUS_FAILURE,
  //
  APPROVE_INSPECTION,
  APPROVE_INSPECTION_SUCCESS,
  APPROVE_INSPECTION_FAILURE,
  //
  SKIP_INSPECTION_ITEMS,
  SKIP_INSPECTION_ITEMS_SUCCESS,
  SKIP_INSPECTION_ITEMS_FAILURE,
  //
  EDIT_MAINTENANCE_INSPECTION,
  EDIT_MAINTENANCE_INSPECTION_SUCCESS,
  EDIT_MAINTENANCE_INSPECTION_FAILURE,
} from "./constants";

export const initialState = {
  dashboardStats: null,
  isFetchingDashboard: false,
  //
  requests: [],
  currentRequest: null,
  requestsTotal: 0,
  isFetchingRequests: false,
  isFetchingRequest: false,
  isSubmittingRequest: false,
  isDeletingRequest: false,
  //
  inspections: [],
  currentInspection: null,
  isUpdatingInspectionStatus: false,
  isApprovingInspection: false,
  inspectionsTotal: 0,
  isFetchingInspections: false,
  isFetchingInspection: false,
  isSubmittingInspection: false,
  //
  assets: [],
  currentAsset: null,
  assetsTotal: 0,
  isFetchingAssets: false,
  isSubmittingAsset: false,
  isDeletingAsset: false,
  assetAddEditModal: { open: false, isEditing: false, asset: null },
  //
  quotes: [],
  currentQuote: null,
  quotesTotal: 0,
  isFetchingQuotes: false,
  isFetchingQuote: false,
  isSubmittingQuote: false,
  isDeletingQuote: false,
  isAcceptingQuote: false,
  //
  compliance: [],
  currentCompliance: null,
  complianceTotal: 0,
  isFetchingCompliance: false,
  isSubmittingCompliance: false,
  isDeletingCompliance: false,
  //
  schedules: [],
  schedulesTotal: 0,
  isFetchingSchedules: false,
  isSubmittingSchedule: false,
  scheduleTemplates: [],
  isFetchingScheduleTemplates: false,
  currentSchedule: null,
  isFetchingSingleSchedule: false,
  currentScheduleTemplate: null,
  isFetchingSingleScheduleTemplate: false,
  isSubmittingScheduleTemplate: false,
  scheduleTemplateAddEditModal: {
    open: false,
    isEditing: false,
    template: null,
  },
  scheduleAddEditModal: {
    open: false,
    isEditing: false,
    schedule: null,
  },
  //
  locationSetting: null,
  isFetchingLocationSetting: false,
  isSavingLocationSetting: false,
  //
  inspectionTemplates: [],
  isFetchingInspectionTemplates: false,
  isSubmittingInspectionTemplate: false,
  templateAddEditModal: { open: false, isEditing: false, template: null },
  //
  cqcReport: null,
  isFetchingCqcReport: false,
  //
  inspectionReport: null,
  isFetchingInspectionReport: false,
  //
  requestCreateModal: {
    open: false,
    failedItems: [],
    requestType: "inspection",
    isEditing: false,
    requestId: null,
    careRoomDetails: null,
  },
  //
  complianceMatrix: [],
  isFetchingComplianceMatrix: false,
  scheduledCompletedChecksReport: null,
  isFetchingScheduledCompletedChecksReport: false,
  monthlyScheduleChecklistReport: null,
  isFetchingMonthlyScheduleChecklistReport: false,
  isExportingMonthlyScheduleChecklistReport: false,
  weeklyScheduleChecklistReport: null,
  isFetchingWeeklyScheduleChecklistReport: false,
  isExportingWeeklyScheduleChecklistReport: false,
  quarterlyScheduleChecklistReport: null,
  isFetchingQuarterlyScheduleChecklistReport: false,
  isExportingQuarterlyScheduleChecklistReport: false,
  annualScheduleChecklistReport: null,
  isFetchingAnnualScheduleChecklistReport: false,
  isExportingAnnualScheduleChecklistReport: false,
  biannualScheduleChecklistReport: null,
  isFetchingBiannualScheduleChecklistReport: false,
  isExportingBiannualScheduleChecklistReport: false,
  dailyScheduleChecklistReport: null,
  isFetchingDailyScheduleChecklistReport: false,
  //
  isSubmittingInvoice: false,
  //
  isEditingInspectionItem: false,
  isSkippingInspectionItems: false,
};

const MaintenanceReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_MAINTENANCE_DASHBOARD:
        draft.isFetchingDashboard = true;
        draft.dashboardStats = null;
        break;
      case FETCH_MAINTENANCE_DASHBOARD_SUCCESS:
        draft.isFetchingDashboard = false;
        draft.dashboardStats = action.payload;
        break;
      case FETCH_MAINTENANCE_DASHBOARD_FAILURE:
        draft.isFetchingDashboard = false;
        draft.dashboardStats = null;
        break;

      case FETCH_MAINTENANCE_REQUESTS:
        draft.isFetchingRequests = true;
        draft.requests = [];
        break;
      case FETCH_MAINTENANCE_REQUESTS_SUCCESS:
        draft.isFetchingRequests = false;
        draft.requests = action.payload?.data || action.payload;
        draft.requestsTotal = action.payload?.total || 0;
        break;
      case FETCH_MAINTENANCE_REQUESTS_FAILURE:
        draft.isFetchingRequests = false;
        draft.requests = [];
        break;

      case ADD_MAINTENANCE_REQUEST:
        draft.isSubmittingRequest = true;
        break;
      case ADD_MAINTENANCE_REQUEST_SUCCESS:
        draft.isSubmittingRequest = false;
        break;
      case ADD_MAINTENANCE_REQUEST_FAILURE:
        draft.isSubmittingRequest = false;
        break;

      case FETCH_MAINTENANCE_REQUEST:
        draft.isFetchingRequest = true;
        draft.currentRequest = null;
        break;
      case FETCH_MAINTENANCE_REQUEST_SUCCESS:
        draft.isFetchingRequest = false;
        draft.currentRequest = action.payload;
        break;
      case FETCH_MAINTENANCE_REQUEST_FAILURE:
        draft.isFetchingRequest = false;
        draft.currentRequest = null;
        break;

      case EDIT_MAINTENANCE_REQUEST:
        draft.isSubmittingRequest = true;
        break;
      case EDIT_MAINTENANCE_REQUEST_SUCCESS:
        draft.isSubmittingRequest = false;
        break;
      case EDIT_MAINTENANCE_REQUEST_FAILURE:
        draft.isSubmittingRequest = false;
        break;

      case DELETE_MAINTENANCE_REQUEST:
        draft.isDeletingRequest = true;
        break;
      case DELETE_MAINTENANCE_REQUEST_SUCCESS:
        draft.isDeletingRequest = false;
        break;
      case DELETE_MAINTENANCE_REQUEST_FAILURE:
        draft.isDeletingRequest = false;
        break;

      case UPDATE_MAINTENANCE_REQUEST_STATUS:
        draft.isSubmittingRequest = true;
        break;
      case UPDATE_MAINTENANCE_REQUEST_STATUS_SUCCESS:
        draft.isSubmittingRequest = false;
        break;
      case UPDATE_MAINTENANCE_REQUEST_STATUS_FAILURE:
        draft.isSubmittingRequest = false;
        break;

      case FETCH_MAINTENANCE_INSPECTIONS:
        draft.isFetchingInspections = true;
        draft.inspections = [];
        break;
      case FETCH_MAINTENANCE_INSPECTIONS_SUCCESS:
        draft.isFetchingInspections = false;
        draft.inspections = action.payload?.data || action.payload;
        draft.inspectionsTotal = action.payload?.total || 0;
        break;
      case FETCH_MAINTENANCE_INSPECTIONS_FAILURE:
        draft.isFetchingInspections = false;
        draft.inspections = [];
        break;

      case ADD_MAINTENANCE_INSPECTION:
        draft.isSubmittingInspection = true;
        break;
      case ADD_MAINTENANCE_INSPECTION_SUCCESS:
        draft.isSubmittingInspection = false;
        break;
      case ADD_MAINTENANCE_INSPECTION_FAILURE:
        draft.isSubmittingInspection = false;
        break;

      case FETCH_MAINTENANCE_INSPECTION:
        draft.isFetchingInspection = true;
        draft.currentInspection = null;
        break;
      case FETCH_MAINTENANCE_INSPECTION_SUCCESS:
        draft.isFetchingInspection = false;
        draft.currentInspection = action.payload;
        break;
      case FETCH_MAINTENANCE_INSPECTION_FAILURE:
        draft.isFetchingInspection = false;
        draft.currentInspection = null;
        break;

      case SUBMIT_MAINTENANCE_INSPECTION:
        draft.isSubmittingInspection = true;
        break;
      case SUBMIT_MAINTENANCE_INSPECTION_SUCCESS:
        draft.isSubmittingInspection = false;
        break;
      case SUBMIT_MAINTENANCE_INSPECTION_FAILURE:
        draft.isSubmittingInspection = false;
        break;

      case UPDATE_INSPECTION_STATUS:
        draft.isUpdatingInspectionStatus = true;
        break;
      case UPDATE_INSPECTION_STATUS_SUCCESS:
        draft.isUpdatingInspectionStatus = false;
        break;
      case UPDATE_INSPECTION_STATUS_FAILURE:
        draft.isUpdatingInspectionStatus = false;
        break;
      case APPROVE_INSPECTION:
        draft.isApprovingInspection = true;
        break;
      case APPROVE_INSPECTION_SUCCESS:
        draft.isApprovingInspection = false;
        break;
      case APPROVE_INSPECTION_FAILURE:
        draft.isApprovingInspection = false;
        break;
      case SKIP_INSPECTION_ITEMS:
        draft.isSkippingInspectionItems = true;
        break;
      case SKIP_INSPECTION_ITEMS_SUCCESS:
        draft.isSkippingInspectionItems = false;
        break;
      case SKIP_INSPECTION_ITEMS_FAILURE:
        draft.isSkippingInspectionItems = false;
        break;

      case EDIT_MAINTENANCE_INSPECTION:
        draft.isEditingInspectionItem = true;
        break;
      case EDIT_MAINTENANCE_INSPECTION_SUCCESS:
        draft.isEditingInspectionItem = false;
        break;
      case EDIT_MAINTENANCE_INSPECTION_FAILURE:
        draft.isEditingInspectionItem = false;
        break;

      case FETCH_MAINTENANCE_ASSETS: {
        draft.isFetchingAssets = true;
        const page = action.payload?.page;
        if (page === 1 || page == null) {
          draft.assets = [];
        }
        break;
      }
      case FETCH_MAINTENANCE_ASSETS_SUCCESS: {
        draft.isFetchingAssets = false;
        const payload = action.payload;
        const page = payload?.current_page ?? 1;
        if (page === 1) {
          draft.assets = payload;
        } else {
          const prevData = Array.isArray(draft.assets?.data)
            ? draft.assets.data
            : [];
          const nextData = Array.isArray(payload?.data) ? payload.data : [];
          draft.assets = {
            ...payload,
            data: [...prevData, ...nextData],
            current_page: page,
          };
        }
        draft.assetsTotal = payload?.total ?? draft.assetsTotal ?? 0;
        break;
      }
      case FETCH_MAINTENANCE_ASSETS_FAILURE:
        draft.isFetchingAssets = false;
        draft.assets = [];
        break;

      case ADD_MAINTENANCE_ASSET:
        draft.isSubmittingAsset = true;
        break;
      case ADD_MAINTENANCE_ASSET_SUCCESS:
        draft.isSubmittingAsset = false;
        break;
      case ADD_MAINTENANCE_ASSET_FAILURE:
        draft.isSubmittingAsset = false;
        break;

      case FETCH_MAINTENANCE_ASSET:
        draft.isFetchingAssets = true;
        draft.currentAsset = null;
        break;
      case FETCH_MAINTENANCE_ASSET_SUCCESS:
        draft.isFetchingAssets = false;
        draft.currentAsset = action.payload;
        break;
      case FETCH_MAINTENANCE_ASSET_FAILURE:
        draft.isFetchingAssets = false;
        draft.currentAsset = null;
        break;

      case EDIT_MAINTENANCE_ASSET:
        draft.isSubmittingAsset = true;
        break;
      case EDIT_MAINTENANCE_ASSET_SUCCESS:
        draft.isSubmittingAsset = false;
        break;
      case EDIT_MAINTENANCE_ASSET_FAILURE:
        draft.isSubmittingAsset = false;
        break;

      case DELETE_MAINTENANCE_ASSET:
        draft.isDeletingAsset = true;
        break;
      case DELETE_MAINTENANCE_ASSET_SUCCESS:
        draft.isDeletingAsset = false;
        break;
      case DELETE_MAINTENANCE_ASSET_FAILURE:
        draft.isDeletingAsset = false;
        break;

      case FETCH_MAINTENANCE_QUOTES:
        draft.isFetchingQuotes = true;
        break;
      case FETCH_MAINTENANCE_QUOTES_SUCCESS:
        draft.isFetchingQuotes = false;
        draft.quotes = action.payload?.data ?? action.payload ?? [];
        draft.quotesTotal = action.payload?.total ?? 0;
        break;
      case FETCH_MAINTENANCE_QUOTES_FAILURE:
        draft.isFetchingQuotes = false;
        break;

      case FETCH_MAINTENANCE_QUOTE:
        draft.isFetchingQuote = true;
        draft.currentQuote = null;
        break;
      case FETCH_MAINTENANCE_QUOTE_SUCCESS:
        draft.isFetchingQuote = false;
        draft.currentQuote = action.payload;
        break;
      case FETCH_MAINTENANCE_QUOTE_FAILURE:
        draft.isFetchingQuote = false;
        draft.currentQuote = null;
        break;

      case ADD_MAINTENANCE_QUOTE:
      case EDIT_MAINTENANCE_QUOTE:
        draft.isSubmittingQuote = true;
        break;
      case ADD_MAINTENANCE_QUOTE_SUCCESS:
      case ADD_MAINTENANCE_QUOTE_FAILURE:
      case EDIT_MAINTENANCE_QUOTE_SUCCESS:
      case EDIT_MAINTENANCE_QUOTE_FAILURE:
        draft.isSubmittingQuote = false;
        break;

      case DELETE_MAINTENANCE_QUOTE:
        draft.isDeletingQuote = true;
        break;
      case DELETE_MAINTENANCE_QUOTE_SUCCESS:
      case DELETE_MAINTENANCE_QUOTE_FAILURE:
        draft.isDeletingQuote = false;
        break;

      case ACCEPT_MAINTENANCE_QUOTE:
        draft.isAcceptingQuote = true;
        break;
      case ACCEPT_MAINTENANCE_QUOTE_SUCCESS:
      case ACCEPT_MAINTENANCE_QUOTE_FAILURE:
        draft.isAcceptingQuote = false;
        break;

      case SET_ASSET_ADD_EDIT_MODAL:
        draft.assetAddEditModal = {
          open: action.payload?.open ?? false,
          isEditing: action.payload?.isEditing ?? false,
          asset: action.payload?.asset ?? null,
        };
        break;

      case FETCH_MAINTENANCE_COMPLIANCE: {
        draft.isFetchingCompliance = true;
        const page = action.payload?.page;
        if (page === 1 || page == null) {
          draft.compliance = [];
        }
        break;
      }
      case FETCH_MAINTENANCE_COMPLIANCE_SUCCESS: {
        draft.isFetchingCompliance = false;
        const payload = action.payload;
        const page = payload?.current_page ?? 1;
        if (page === 1) {
          draft.compliance = payload;
        } else {
          const prevData = Array.isArray(draft.compliance?.data)
            ? draft.compliance.data
            : [];
          const nextData = Array.isArray(payload?.data) ? payload.data : [];
          draft.compliance = {
            ...payload,
            data: [...prevData, ...nextData],
            current_page: page,
          };
        }
        draft.complianceTotal = payload?.total ?? draft.complianceTotal ?? 0;
        break;
      }
      case FETCH_MAINTENANCE_COMPLIANCE_FAILURE:
        draft.isFetchingCompliance = false;
        draft.compliance = [];
        break;

      case ADD_MAINTENANCE_COMPLIANCE:
        draft.isSubmittingCompliance = true;
        break;
      case ADD_MAINTENANCE_COMPLIANCE_SUCCESS:
        draft.isSubmittingCompliance = false;
        break;
      case ADD_MAINTENANCE_COMPLIANCE_FAILURE:
        draft.isSubmittingCompliance = false;
        break;

      case FETCH_MAINTENANCE_COMPLIANCE_ITEM:
        draft.isFetchingCompliance = true;
        draft.currentCompliance = null;
        break;
      case FETCH_MAINTENANCE_COMPLIANCE_ITEM_SUCCESS:
        draft.isFetchingCompliance = false;
        draft.currentCompliance = action.payload;
        break;
      case FETCH_MAINTENANCE_COMPLIANCE_ITEM_FAILURE:
        draft.isFetchingCompliance = false;
        draft.currentCompliance = null;
        break;

      case EDIT_MAINTENANCE_COMPLIANCE:
        draft.isSubmittingCompliance = true;
        break;
      case EDIT_MAINTENANCE_COMPLIANCE_SUCCESS:
        draft.isSubmittingCompliance = false;
        break;
      case EDIT_MAINTENANCE_COMPLIANCE_FAILURE:
        draft.isSubmittingCompliance = false;
        break;

      case DELETE_MAINTENANCE_COMPLIANCE:
        draft.isDeletingCompliance = true;
        break;
      case DELETE_MAINTENANCE_COMPLIANCE_SUCCESS:
        draft.isDeletingCompliance = false;
        break;
      case DELETE_MAINTENANCE_COMPLIANCE_FAILURE:
        draft.isDeletingCompliance = false;
        break;

      case FETCH_MAINTENANCE_SCHEDULES: {
        draft.isFetchingSchedules = true;
        const page = action.payload?.page;
        if (page === 1 || page == null) {
          draft.schedules = [];
        }
        break;
      }
      case FETCH_MAINTENANCE_SCHEDULES_SUCCESS:
        draft.isFetchingSchedules = false;
        draft.schedules = action.payload;
        break;
      case FETCH_MAINTENANCE_SCHEDULES_FAILURE:
        draft.isFetchingSchedules = false;
        draft.schedules = [];
        break;

      case ADD_MAINTENANCE_SCHEDULE:
        draft.isSubmittingSchedule = true;
        break;
      case ADD_MAINTENANCE_SCHEDULE_SUCCESS:
        draft.isSubmittingSchedule = false;
        break;
      case ADD_MAINTENANCE_SCHEDULE_FAILURE:
        draft.isSubmittingSchedule = false;
        break;

      case EDIT_MAINTENANCE_SCHEDULE:
        draft.isSubmittingSchedule = true;
        break;
      case EDIT_MAINTENANCE_SCHEDULE_SUCCESS:
        draft.isSubmittingSchedule = false;
        break;
      case EDIT_MAINTENANCE_SCHEDULE_FAILURE:
        draft.isSubmittingSchedule = false;
        break;

      case DELETE_MAINTENANCE_SCHEDULE:
        draft.isSubmittingSchedule = true;
        break;
      case DELETE_MAINTENANCE_SCHEDULE_SUCCESS:
        draft.isSubmittingSchedule = false;
        break;
      case DELETE_MAINTENANCE_SCHEDULE_FAILURE:
        draft.isSubmittingSchedule = false;
        break;

      case GET_MAINTENANCE_SCHEDULE:
        draft.isFetchingSingleSchedule = true;
        draft.currentSchedule = null;
        break;
      case GET_MAINTENANCE_SCHEDULE_SUCCESS:
        draft.isFetchingSingleSchedule = false;
        draft.currentSchedule = action.payload;
        break;
      case GET_MAINTENANCE_SCHEDULE_FAILURE:
        draft.isFetchingSingleSchedule = false;
        draft.currentSchedule = null;
        break;

      case SET_SCHEDULE_ADD_EDIT_MODAL:
        draft.scheduleAddEditModal = {
          open: action.payload?.open ?? false,
          isEditing: action.payload?.isEditing ?? false,
          schedule: action.payload?.schedule ?? null,
        };
        break;

      case ACTIVATE_ALL_PRESETS:
        draft.isSubmittingSchedule = true;
        break;
      case ACTIVATE_ALL_PRESETS_SUCCESS:
        draft.isSubmittingSchedule = false;
        break;
      case ACTIVATE_ALL_PRESETS_FAILURE:
        draft.isSubmittingSchedule = false;
        break;

      case FETCH_MAINTENANCE_LOCATION_SETTING:
        draft.isFetchingLocationSetting = true;
        draft.locationSetting = null;
        break;
      case FETCH_MAINTENANCE_LOCATION_SETTING_SUCCESS:
        draft.isFetchingLocationSetting = false;
        draft.locationSetting = action.payload;
        break;
      case FETCH_MAINTENANCE_LOCATION_SETTING_FAILURE:
        draft.isFetchingLocationSetting = false;
        draft.locationSetting = null;
        break;

      case SAVE_MAINTENANCE_LOCATION_SETTING:
        draft.isSavingLocationSetting = true;
        break;
      case SAVE_MAINTENANCE_LOCATION_SETTING_SUCCESS:
        draft.isSavingLocationSetting = false;
        draft.locationSetting = action.payload;
        break;
      case SAVE_MAINTENANCE_LOCATION_SETTING_FAILURE:
        draft.isSavingLocationSetting = false;
        break;

      case FETCH_INSPECTION_TEMPLATES: {
        draft.isFetchingInspectionTemplates = true;
        const page = action.payload?.page;
        if (page === 1 || page == null) {
          draft.inspectionTemplates = [];
        }
        break;
      }
      case FETCH_INSPECTION_TEMPLATES_SUCCESS:
        draft.isFetchingInspectionTemplates = false;
        draft.inspectionTemplates = action.payload;
        break;
      case FETCH_INSPECTION_TEMPLATES_FAILURE:
        draft.isFetchingInspectionTemplates = false;
        draft.inspectionTemplates = [];
        break;

      case ADD_INSPECTION_TEMPLATE:
        draft.isSubmittingInspectionTemplate = true;
        break;
      case ADD_INSPECTION_TEMPLATE_SUCCESS:
        draft.isSubmittingInspectionTemplate = false;
        break;
      case ADD_INSPECTION_TEMPLATE_FAILURE:
        draft.isSubmittingInspectionTemplate = false;
        break;

      case EDIT_INSPECTION_TEMPLATE:
        draft.isSubmittingInspectionTemplate = true;
        break;
      case EDIT_INSPECTION_TEMPLATE_SUCCESS:
        draft.isSubmittingInspectionTemplate = false;
        break;
      case EDIT_INSPECTION_TEMPLATE_FAILURE:
        draft.isSubmittingInspectionTemplate = false;
        break;

      case DELETE_INSPECTION_TEMPLATE:
        draft.isSubmittingInspectionTemplate = true;
        break;
      case DELETE_INSPECTION_TEMPLATE_SUCCESS:
        draft.isSubmittingInspectionTemplate = false;
        break;
      case DELETE_INSPECTION_TEMPLATE_FAILURE:
        draft.isSubmittingInspectionTemplate = false;
        break;

      case CLONE_INSPECTION_TEMPLATE:
        draft.isSubmittingInspectionTemplate = true;
        break;
      case CLONE_INSPECTION_TEMPLATE_SUCCESS:
        draft.isSubmittingInspectionTemplate = false;
        break;
      case CLONE_INSPECTION_TEMPLATE_FAILURE:
        draft.isSubmittingInspectionTemplate = false;
        break;

      case SET_TEMPLATE_ADD_EDIT_MODAL:
        draft.templateAddEditModal = {
          open: action.payload?.open ?? false,
          isEditing: action.payload?.isEditing ?? false,
          template: action.payload?.template ?? null,
        };
        break;

      case ADD_INSPECTION_FROM_TEMPLATE:
        draft.isSubmittingInspection = true;
        break;
      case ADD_INSPECTION_FROM_TEMPLATE_SUCCESS:
        draft.isSubmittingInspection = false;
        break;
      case ADD_INSPECTION_FROM_TEMPLATE_FAILURE:
        draft.isSubmittingInspection = false;
        break;

      case FETCH_CQC_REPORT:
        draft.isFetchingCqcReport = true;
        draft.cqcReport = null;
        break;
      case FETCH_CQC_REPORT_SUCCESS:
        draft.isFetchingCqcReport = false;
        draft.cqcReport = action.payload;
        break;
      case FETCH_CQC_REPORT_FAILURE:
        draft.isFetchingCqcReport = false;
        draft.cqcReport = null;
        break;

      case FETCH_INSPECTION_REPORT:
        draft.isFetchingInspectionReport = true;
        draft.inspectionReport = null;
        break;
      case FETCH_INSPECTION_REPORT_SUCCESS:
        draft.isFetchingInspectionReport = false;
        draft.inspectionReport = action.payload;
        break;
      case FETCH_INSPECTION_REPORT_FAILURE:
        draft.isFetchingInspectionReport = false;
        draft.inspectionReport = null;
        break;

      case SET_REQUEST_CREATE_MODAL:
        draft.requestCreateModal = {
          open: action.payload?.open ?? false,
          failedItems: action.payload?.failedItems ?? [],
          requestType: action.payload?.requestType ?? "inspection",
          isEditing: action.payload?.isEditing ?? false,
          requestId: action.payload?.requestId ?? null,
          careRoomDetails: action.payload?.careRoomDetails ?? null,
          categoryType: action.payload?.categoryType ?? null,
          onSuccess: action.payload?.onSuccess ?? null,
          title: action.payload?.title ?? null,
        };
        if (!action.payload?.open || action.payload?.isEditing) {
          draft.currentRequest = null;
        }
        break;

      case FETCH_COMPLIANCE_MATRIX:
        draft.isFetchingComplianceMatrix = true;
        draft.complianceMatrix = [];
        break;
      case FETCH_COMPLIANCE_MATRIX_SUCCESS:
        draft.isFetchingComplianceMatrix = false;
        draft.complianceMatrix = action.payload;
        break;
      case FETCH_COMPLIANCE_MATRIX_FAILURE:
        draft.isFetchingComplianceMatrix = false;
        draft.complianceMatrix = [];
        break;

      case FETCH_SCHEDULED_COMPLETED_CHECKS_REPORT:
        draft.isFetchingScheduledCompletedChecksReport = true;
        draft.scheduledCompletedChecksReport = null;
        break;
      case FETCH_SCHEDULED_COMPLETED_CHECKS_REPORT_SUCCESS:
        draft.isFetchingScheduledCompletedChecksReport = false;
        draft.scheduledCompletedChecksReport = action.payload;
        break;
      case FETCH_SCHEDULED_COMPLETED_CHECKS_REPORT_FAILURE:
        draft.isFetchingScheduledCompletedChecksReport = false;
        draft.scheduledCompletedChecksReport = null;
        break;

      case FETCH_MONTHLY_SCHEDULE_CHECKLIST_REPORT:
        draft.isFetchingMonthlyScheduleChecklistReport = true;
        draft.monthlyScheduleChecklistReport = null;
        break;
      case FETCH_MONTHLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS:
        draft.isFetchingMonthlyScheduleChecklistReport = false;
        draft.monthlyScheduleChecklistReport = action.payload;
        break;
      case FETCH_MONTHLY_SCHEDULE_CHECKLIST_REPORT_FAILURE:
        draft.isFetchingMonthlyScheduleChecklistReport = false;
        draft.monthlyScheduleChecklistReport = null;
        break;
      case EXPORT_MONTHLY_SCHEDULE_CHECKLIST_REPORT:
        draft.isExportingMonthlyScheduleChecklistReport = true;
        break;
      case EXPORT_MONTHLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS:
      case EXPORT_MONTHLY_SCHEDULE_CHECKLIST_REPORT_FAILURE:
        draft.isExportingMonthlyScheduleChecklistReport = false;
        break;

      case FETCH_WEEKLY_SCHEDULE_CHECKLIST_REPORT:
        draft.isFetchingWeeklyScheduleChecklistReport = true;
        draft.weeklyScheduleChecklistReport = null;
        break;
      case FETCH_WEEKLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS:
        draft.isFetchingWeeklyScheduleChecklistReport = false;
        draft.weeklyScheduleChecklistReport = action.payload;
        break;
      case FETCH_WEEKLY_SCHEDULE_CHECKLIST_REPORT_FAILURE:
        draft.isFetchingWeeklyScheduleChecklistReport = false;
        draft.weeklyScheduleChecklistReport = null;
        break;
      case EXPORT_WEEKLY_SCHEDULE_CHECKLIST_REPORT:
        draft.isExportingWeeklyScheduleChecklistReport = true;
        break;
      case EXPORT_WEEKLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS:
      case EXPORT_WEEKLY_SCHEDULE_CHECKLIST_REPORT_FAILURE:
        draft.isExportingWeeklyScheduleChecklistReport = false;
        break;

      case FETCH_QUARTERLY_SCHEDULE_CHECKLIST_REPORT:
        draft.isFetchingQuarterlyScheduleChecklistReport = true;
        draft.quarterlyScheduleChecklistReport = null;
        break;
      case FETCH_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS:
        draft.isFetchingQuarterlyScheduleChecklistReport = false;
        draft.quarterlyScheduleChecklistReport = action.payload;
        break;
      case FETCH_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_FAILURE:
        draft.isFetchingQuarterlyScheduleChecklistReport = false;
        draft.quarterlyScheduleChecklistReport = null;
        break;
      case EXPORT_QUARTERLY_SCHEDULE_CHECKLIST_REPORT:
        draft.isExportingQuarterlyScheduleChecklistReport = true;
        break;
      case EXPORT_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_SUCCESS:
      case EXPORT_QUARTERLY_SCHEDULE_CHECKLIST_REPORT_FAILURE:
        draft.isExportingQuarterlyScheduleChecklistReport = false;
        break;

      case FETCH_ANNUAL_SCHEDULE_CHECKLIST_REPORT:
        draft.isFetchingAnnualScheduleChecklistReport = true;
        draft.annualScheduleChecklistReport = null;
        break;
      case FETCH_ANNUAL_SCHEDULE_CHECKLIST_REPORT_SUCCESS:
        draft.isFetchingAnnualScheduleChecklistReport = false;
        draft.annualScheduleChecklistReport = action.payload;
        break;
      case FETCH_ANNUAL_SCHEDULE_CHECKLIST_REPORT_FAILURE:
        draft.isFetchingAnnualScheduleChecklistReport = false;
        draft.annualScheduleChecklistReport = null;
        break;
      case EXPORT_ANNUAL_SCHEDULE_CHECKLIST_REPORT:
        draft.isExportingAnnualScheduleChecklistReport = true;
        break;
      case EXPORT_ANNUAL_SCHEDULE_CHECKLIST_REPORT_SUCCESS:
      case EXPORT_ANNUAL_SCHEDULE_CHECKLIST_REPORT_FAILURE:
        draft.isExportingAnnualScheduleChecklistReport = false;
        break;

      case FETCH_BIANNUAL_SCHEDULE_CHECKLIST_REPORT:
        draft.isFetchingBiannualScheduleChecklistReport = true;
        draft.biannualScheduleChecklistReport = null;
        break;
      case FETCH_BIANNUAL_SCHEDULE_CHECKLIST_REPORT_SUCCESS:
        draft.isFetchingBiannualScheduleChecklistReport = false;
        draft.biannualScheduleChecklistReport = action.payload;
        break;
      case FETCH_BIANNUAL_SCHEDULE_CHECKLIST_REPORT_FAILURE:
        draft.isFetchingBiannualScheduleChecklistReport = false;
        draft.biannualScheduleChecklistReport = null;
        break;
      case EXPORT_BIANNUAL_SCHEDULE_CHECKLIST_REPORT:
        draft.isExportingBiannualScheduleChecklistReport = true;
        break;
      case EXPORT_BIANNUAL_SCHEDULE_CHECKLIST_REPORT_SUCCESS:
      case EXPORT_BIANNUAL_SCHEDULE_CHECKLIST_REPORT_FAILURE:
        draft.isExportingBiannualScheduleChecklistReport = false;
        break;

      case FETCH_DAILY_SCHEDULE_CHECKLIST_REPORT:
        draft.isFetchingDailyScheduleChecklistReport = true;
        draft.dailyScheduleChecklistReport = null;
        break;
      case FETCH_DAILY_SCHEDULE_CHECKLIST_REPORT_SUCCESS:
        draft.isFetchingDailyScheduleChecklistReport = false;
        draft.dailyScheduleChecklistReport = action.payload;
        break;
      case FETCH_DAILY_SCHEDULE_CHECKLIST_REPORT_FAILURE:
        draft.isFetchingDailyScheduleChecklistReport = false;
        draft.dailyScheduleChecklistReport = null;
        break;

      case ADD_MAINTENANCE_INVOICE:
      case EDIT_MAINTENANCE_INVOICE:
      case DELETE_MAINTENANCE_INVOICE:
        draft.isSubmittingInvoice = true;
        break;
      case ADD_MAINTENANCE_INVOICE_SUCCESS:
      case EDIT_MAINTENANCE_INVOICE_SUCCESS:
      case DELETE_MAINTENANCE_INVOICE_SUCCESS:
        draft.isSubmittingInvoice = false;
        break;
      case ADD_MAINTENANCE_INVOICE_FAILURE:
      case EDIT_MAINTENANCE_INVOICE_FAILURE:
      case DELETE_MAINTENANCE_INVOICE_FAILURE:
        draft.isSubmittingInvoice = false;
        break;

      default:
        return state;
    }
  });

export default MaintenanceReducer;
